module.exports = __webpack_public_path__ + "img/hotellasignoria.00deec51.jpg";